import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { useContext } from "react";
import { ThemeContext } from "../contexts/ThemeProvider";
import { LanguageContext } from "../contexts/LanguageProvider";

export default function Navbar() {
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setShowNavbar(currentScrollY > 10);

      setScrolledPastHero(currentScrollY > 120);

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const { colorsObj } = useContext(ThemeContext);
  const { language, setLanguage } = useContext(LanguageContext);
  return (
    <motion.nav
      className={`
    fixed top-0 left-0 w-full z-50
    flex items-center justify-between px-8 md:px-24 lg:px-44 2xl:px-64 py-4
    gap-4 transition-all duration-300 
    ${
      scrolledPastHero
        ? `text-[${colorsObj.colorText}] shadow-md`
        : `text-white`
    }
    ${showNavbar ? `translate-y-0 opacity-100` : `-translate-y-full opacity-0`}
  `}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      style={
        scrolledPastHero
          ? {
              backgroundColor: `${colorsObj.colorBackground}`,
              backgroundImage:
                `repeating-radial-gradient( circle at 0 0, transparent 0, ${colorsObj.colorBackground} 16px ), ` +
                ` repeating-linear-gradient(  ${colorsObj.colorOverlay}, ${colorsObj.colorBackground} )`,
              opacity: 1,
            }
          : { backgroundColor: "transparent" }
      }
    >
      <div className="flex items-center justify-start gap-4">
        <img src="/logo-omnia.png" alt="Omnia360 Logo" className="w-10" />
        <Link
          to="/"
          className="font-semibold text-lg "
          style={{
            color: colorsObj.colorText,
          }}
        >
          Omnia360
        </Link>
      </div>
      <div className="flex gap-6 text-sm font-normal">
        {/* <Link to="/" className="hover:underline">
          Home
        </Link>
        <Link to="/about" className="hover:underline">
          About
        </Link> */}
        {/* <motion.button
          onClick={toggleTheme}
          className="w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-300
             bg-gray-300 dark:bg-gray-600 hover:bg-yellow-400"
          whileTap={{ scale: 0.95 }}
          aria-label="Toggle theme"
        >
          <motion.div
            key={theme}
            initial={{ rotate: -90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: 90, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {theme === "dark" ? (
              <svg
                className="w-6 h-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  d="M11.675 2.015a.998.998 0 0 0-.403.011C6.09 2.4 2 6.722 2 12c0 5.523 4.477 10 10 10 4.356 0 8.058-2.784 9.43-6.667a1 1 0 0 0-1.02-1.33c-.08.006-.105.005-.127.005h-.001l-.028-.002A5.227 5.227 0 0 0 20 14a8 8 0 0 1-8-8c0-.952.121-1.752.404-2.558a.996.996 0 0 0 .096-.428V3a1 1 0 0 0-.825-.985Z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6 text-yellow-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  d="M13 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V3ZM6.343 4.929A1 1 0 0 0 4.93 6.343l1.414 1.414a1 1 0 0 0 1.414-1.414L6.343 4.929Zm12.728 1.414a1 1 0 0 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 1.414 1.414l1.414-1.414ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-9 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H3Zm16 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM7.757 17.657a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414Zm9.9-1.414a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM13 19a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </motion.div>
        </motion.button>
*/}
        <motion.button
          onClick={() => {
            setLanguage(language === "ro" ? "en" : "ro");
          }}
          className="w-10 h-10 flex items-center justify-center rounded-full 
             bg-gray-300 dark:bg-gray-600 text-sm font-semibold shadow 
             hover:bg-yellow-400 transition-colors duration-300"
          whileTap={{ scale: 0.9 }}
          aria-label="Toggle language"
        >
          <motion.span
            key={language}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            {language === "ro" ? "🇷🇴" : "🇬🇧"}
          </motion.span>
        </motion.button>
      </div>
    </motion.nav>
  );
}
